import { __require as i } from "./_ListCache.js";
var r, e;
function _() {
  if (e) return r;
  e = 1;
  var a = i();
  function t() {
    this.__data__ = new a(), this.size = 0;
  }
  return r = t, r;
}
export {
  _ as __require
};
